import { all, put, takeEvery } from "redux-saga/effects";
import {
  loginWithEmailAndPassword,
  logout
} from "../../Services/authentication";
import { setErrorStatus } from "../status/action";

export const authActionTypes = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  ADD_AUTH_INFO: "ADD_AUTH_INFO"
};

function* loginWorker(action) {
  try {
    yield setAuthLoading(true);
    yield loginWithEmailAndPassword(action.payload);
    yield setAuthLoading(false);
  } catch (error) {
    yield setErrorStatus(error);
    yield setAuthLoading(false);
  }
}

function* logoutWorker() {
  try {
    yield setAuthLoading(true);
    yield logout();
    yield put({ type: "RESET" });
    yield setAuthLoading(false);
  } catch (error) {
    yield setErrorStatus(error);
    yield setAuthLoading(false);
  }
}

function* addAuthInfoWorker(action) {
  try {
    yield put({ type: "SET_AUTH_INFO", payload: action.payload });
  } catch (error) {
    yield setErrorStatus(error);
  }
}

export default function* authWatcher() {
  yield all([
    takeEvery("LOGIN", loginWorker),
    takeEvery("LOGOUT", logoutWorker),
    takeEvery("ADD_AUTH_INFO", addAuthInfoWorker)
  ]);
}

function* setAuthLoading(value) {
  yield put({ type: "SET_AUTH_LOADING", payload: { loading: value } });
}
